<section class="card run-site" [attr.aria-labelledby]="'run-site-heading-' + domain">
  <button type="button" class="run-site-toggle" (click)="toggle()" [attr.aria-expanded]="expanded">
    <span [attr.id]="'run-site-heading-' + domain" class="run-site-title">Crawl history</span>
    <span class="run-site-toggle-hint" *ngIf="payload">
      {{ payload.runsCaptured }} captured run{{ payload.runsCaptured === 1 ? '' : 's' }}
    </span>
    <span class="run-site-chevron">{{ expanded ? '▾' : '▸' }}</span>
  </button>

  <div class="run-site-body" *ngIf="expanded">
    <p class="run-site-note" *ngIf="loading">Loading captured crawl runs…</p>
    <p class="run-site-note run-site-note--error" *ngIf="error">{{ error }}</p>

    <ng-container *ngIf="!loading && !error && payload">
      <p class="run-site-note" *ngIf="!hasRuns()">
        No crawl run has been captured for this domain yet. A run is captured once post-crawl enrichment
        goes quiet, not when the crawl finishes.
      </p>

      <ng-container *ngIf="hasRuns()">
        <ol class="run-site-runs">
          <li
            *ngFor="let run of payload.runs"
            class="run-site-run"
            [class.run-site-run--selected]="run.crawlRunId === currentRunId()"
          >
            <button
              type="button"
              class="btn btn--bare btn--sm btn--block run-site-run-button"
              (click)="selectRun(run)"
            >
              <span class="run-site-run-date">{{ runLabel(run) }}</span>
              <span class="run-site-run-meta">{{ runQualifier(run) }}</span>
            </button>
          </li>
        </ol>

        <ng-container *ngIf="diff() as siteDiff">
          <p class="run-site-headline" [ngClass]="'run-site-headline--' + siteDiff.state">
            {{ siteDiff.headline }}
          </p>

          <ul class="run-site-notes" *ngIf="siteDiff.notes.length">
            <li *ngFor="let note of siteDiff.notes">{{ note }}</li>
          </ul>

          <ng-container *ngIf="hasComparison()">
            <div class="run-site-tiles">
              <div
                class="card card--edge run-site-tile"
                *ngFor="let bucket of headlineBuckets()"
                [ngClass]="bucketClass(bucket.bucket)"
                [attr.title]="bucket.description"
              >
                <span class="run-site-tile-count">{{ bucket.count }}</span>
                <span class="run-site-tile-label">{{ bucket.label }}</span>
              </div>
            </div>

            <details class="run-site-list" *ngFor="let bucket of listedBuckets()">
              <summary>
                <span class="run-site-list-label">{{ bucket.label }}</span>
                <span class="run-site-list-count">{{ bucket.count }}</span>
              </summary>
              <!--
                The description is the difference between "reworked" and "the
                footer changed on every page". It is shown, not hidden in a
                tooltip, because those two are the states an operator is most
                likely to read as the same thing.
              -->
              <p class="run-site-list-description">{{ bucket.description }}</p>
              <p class="run-site-list-truncated" *ngIf="bucket.truncated">
                Showing the first {{ bucket.entries.length }} of {{ bucket.count }}.
              </p>
              <ul class="run-site-entries">
                <li *ngFor="let entry of bucket.entries">
                  <span class="run-site-entry-url">{{ entry.url }}</span>
                  <span class="run-site-entry-display">{{ entry.display }}</span>
                  <span class="run-site-entry-note" *ngIf="entryNote(entry) as note">{{ note }}</span>
                </li>
              </ul>
            </details>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</section>
